import React from 'react'

const Home = () => {
  return (
    <div className='background' style={{height: '100vh', width: '100%', overflow: 'hidden'}}>
        <iframe
        src="https://hegdefertility.com/lp/hospital/?utm_campaign=BestFertilityHospitalHyd&utm_keyword=fertility%20hospital&utm_device=c&utm_adgroupID=173137773354&utm_locID=9062147&utm_locationInterest=&utm_network=g&utm_creativeID=726996958303&utm_placement=&utm_adposition=&utm_adgroupname=AdGroup-1&utm_source=GoogleSearchAds&gad_source=1&gbraid=0AAAAADBbGUGCKEegfCeoCkwVtTKcN9GFK&gclid=Cj0KCQjw2ZfABhDBARIsAHFTxGzDQGSejcGP_JgTZZTqNErUlh5GRM01oybsVdAZ1tFICiWHCiNerT8aAqo8EALw_wcB"
        title="External Website"
        style={{ border: 'none', height: '100%', width: '100%' }}
      ></iframe>
    </div>
  )
}

export default Home